<template>
  <hr class="phxsg-divider" role="separator" />
</template>

<style src="./divider.css" />
